/**
 * Application Configuration
 *
 * This file contains configuration values used throughout the application.
 */

/**
 * Contact Form API Endpoint
 *
 * N8N Webhook endpoint for form submissions
 */
export const CONTACT_FORM_ENDPOINT = process.env.REACT_APP_WEBHOOK_URL || '';

// Validate that webhook URL is configured
if (!CONTACT_FORM_ENDPOINT) {
  console.warn('Warning: REACT_APP_WEBHOOK_URL is not configured. Form submissions will fail.');
}

/**
 * Form submission timeout (in milliseconds)
 * Default: 10 seconds
 */
export const FORM_TIMEOUT = 10000;
